export { default } from './AuthTemplate';



// WEBPACK FOOTER //
// ./src/components/auth/AuthTemplate/index.js